import React from 'react';
import { connect } from 'react-redux';
import Container from "@material-ui/core/Container";
import { bindActionCreators } from 'redux';
import { actionCreators as authActions } from '../redux/actions/authActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import LockIcon from '@material-ui/icons/Lock';
import * as authHelpers from './authHelpers';
import * as routeHelpers from './routeHelpers';
import './auth.css';

class Verification extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			code: '',
			errorMessage: '',
			successMessage: ''
		};
	}

	resetFormAndShowError(error) {
		this.setState((state) => ({
			...state,
			errorMessage: error,
			successMessage: '',
			code: '',
		}));
	}

	handleSubmit = (event) => {
		event.preventDefault();

		this.setState((state) => ({
			...state,
			errorMessage: '',
			successMessage: ''
		}));

		let accountUniqueName = authHelpers.getAccountUniqueNameFromUrl();

		let user = authHelpers.getAuthUser();
		let accessToken = user?.token;

		let unlockCode2 = this.retrieveUnlockCode2();

		if (accessToken) {
			this.props
				.register(this.state.code, accessToken, unlockCode2, accountUniqueName)
				.then(() => {
					this.props.history.push(routeHelpers.buildRoute('/acceptance-of-terms'));
				})
				.catch((error) => {
					this.resetFormAndShowError(
						error?.errorMessage ? error?.errorMessage : 'The code entered was invalid, please try again.'
					);
				});
		} else {
			this.props.history.push(routeHelpers.buildRoute('/login'));
		}
	};

	retrieveUnlockCode2 = () => {
		const params = new URLSearchParams(this.props.location.search);
		let unlockCode2 = params.get('c');

		return unlockCode2;
	}

	handleVerificationChange = (event) => {
		const { value } = event.target; // <-- moved outside asynchronous context
		this.setState((state) => ({
			...state,
			code: value.trim(),
		}));
	};

	resendVerificationcode = async (event) => {
		event.preventDefault();

		let unlockCode2 = this.retrieveUnlockCode2();
		let accountUniqueName = authHelpers.getAccountUniqueNameFromUrl();

		let obj = {
			AccountUniqueName: accountUniqueName,
			UnlockCode2: unlockCode2
		};

		const error = await this.props.resetVerificationCode(obj);

		if (error) {
			this.setState((state) => ({
				...state,
				errorMessage: error,
				successMessage: ''
			}));
		}
		else {
			this.setState((state) => ({
				...state,
				errorMessage: '',
				successMessage: 'Successfuly re-sent verification code. Please check your inbox.'
			}));
		}
	};

	render() {
		return (
			<Container maxWidth="sm">
				<>
					<div style={{ marginBottom: 10, color: 'green' }}>{this.state.successMessage ? <>{this.state.successMessage}</> : ''}</div>
					<div style={{ marginBottom: 10, color: 'red' }}>{this.state.errorMessage ? <>{this.state.errorMessage}</> : ''}</div>

					<Typography component='h1' variant='subtitle1' className='login-title'>
						<LockIcon style={{ verticalAlign: 'text-bottom', marginRight: 5 }} />
						Additional Security - Verification
					</Typography>

					<Typography color='textSecondary' gutterBottom>
						Please enter the code that has been sent to your email address to proceed.
					</Typography>

					<Divider />

					<form onSubmit={this.handleSubmit}>
						<TextField
							variant='outlined'
							type='text'
							margin='normal'
							value={this.state.code}
							onChange={this.handleVerificationChange}
							required
							fullWidth
							id='code'
							label='Code'
							name='code'
							InputLabelProps={{
								shrink: true,
							}}
						/>

						<Button type='submit' fullWidth variant='contained' color='primary'>
							Sign In
						</Button>
					</form>

					<Box mt={2}>
						<Typography color='textSecondary' gutterBottom>
							Click <b onClick={this.resendVerificationcode} style={{ cursor: 'pointer' }}>here</b> to resend verification code.
						</Typography>
					</Box>
				</>
			</Container>
		);
	}
}

export default connect(
	(state) => state.authentication,
	(dispatch) => bindActionCreators(authActions, dispatch)
)(Verification);
